import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import type { StudentType } from '@chancenwerk/db/enums/enums.js';

@Entity()
export class PollClick extends MongoEntity {
  static override _class = 'PollClick';
  static override _collectionName = 'poll-clicks';

  @validate(nonOptional())
  @Field(type => String)
  public pollId: Maybe<string>;

  @validate(nonOptional())
  @Field(type => String)
  public userId: Maybe<string>;
}

@Entity()
export class PollKV extends AdornisEntity {
  static override _class = 'PollKV';

  static override resolveID(entity: any): string {
    return `${entity.pollKey}=${entity.entityField}`;
  }

  @validate(nonOptional())
  @Field(type => String)
  public pollKey: Maybe<string>;

  @validate(nonOptional())
  @Field(type => String)
  public entityField: Maybe<string>;
}

@Entity()
export class PollLink extends MongoEntity {
  static override _class = 'PollLink';
  static override _collectionName = 'poll-links';

  @Field(type => Boolean)
  public public: Maybe<boolean>;

  @validate(nonOptional())
  @Field(type => String)
  public showClass: Maybe<string>;

  @Field(type => String)
  public studentType: Maybe<StudentType>;

  @Field(type => [String])
  public products: Maybe<string[]>;

  @Field(type => [String])
  public roles: Maybe<string[]>;

  @validate(nonOptional())
  @Field(type => String)
  public name: Maybe<string>;

  @validate(nonOptional())
  @Field(type => String)
  public url: Maybe<string>;

  @validate(nonOptional())
  @Field(type => [PollKV])
  public mapping: Maybe<PollKV[]>;
}
